import { CALL_API } from '../middleware';

export type checkWhitelistedResponceBody = {
  id: string;
  firstName: string;
  lastName: string;
  countryCode: string;
  countryNameAndCode: string;
  phone: string;
  email: string;
  role: string;
  createdBy: string;
  updatedBy: string;
  isActive: boolean;
  isEmailWhiteListed: boolean;
  createdAt: string;
  updatedAt: string;
};

export type whitelistUnlockUserRequestBody = {
  email: string;
  // countryCode: string;
};

export type checkWhitelistRequestBody = {
  email: string;
  // countryCode: string;
  whiteList: boolean;
};
export type fromExpire = {
  applicationNumber: string;
  applicationStatus: string;
};
export type moveToDraft = {
  applicationNumber: string;
  // deleteLeegalityDocument: boolean;
};

export type createTopUpMoveDistributor = {
  applicationNumber: string;
  distributor_id?: number | null;
  subdistributorId?: number | null;
  supportSubdistributorId?: number | null;
  rm_id: number | null;
  distributorType: string | null;
  distributorName: string | null;
  distributorArnCode: string | null;
  distributorRmName: string | null;
};

export type makeCompleted = {
  applicationNumber: string;
};

export type supportTypeBody = {
  message: string;
};

export type unlockAccessBody = {
  unlockingAccess: boolean;
};

export type whitelistAccessBody = {
  whitelistingAccess: boolean;
};

export type statusAccessBody = {
  applicationStatusChangeAccess: boolean;
};

const UNLOCK_USER_SUCCESS = 'UNLOCK_USER_SUCCESS';
const UNLOCK_USER = 'UNLOCK_USER';

const WHITELIST_USER_SUCCESS = 'WHITELIST_USER_SUCCESS';
const WHITELIST_USER = 'WHITELIST_USER';

const CHECK_WHITELIST_USER_SUCCESS = 'CHECK_WHITELIST_USER_SUCCESS';
const CHECK_WHITELIST_USER = 'CHECK_WHITELIST_USER_SUCCESS';

const UNLOCK_USER_ACCESS_SUCCESS = 'UNLOCK_USER_ACCESS_SUCCESS';
const UNLOCK_USER_ACCESS = 'UNLOCK_USER_ACCESS';

const WHITELIST_USER_ACCESS_SUCCESS = 'WHITELIST_USER_ACCESS_SUCCESS';
const WHITELIST_USER_ACCESS = 'WHITELIST_USER_ACCESS';

const STATUS_ACCESS_SUCCESS = 'STATUS_ACCESS_SUCCESS';
const STATUS_ACCESS = 'STATUS_ACCESS';

const STATUS_CHANGE_FROM_EXPIRED_SUCCESS = 'STATUS_CHANGE_FROM_EXPIRED_SUCCESS';
const STATUS_CHANGE_FROM_EXPIRED = 'STATUS_CHANGE_FROM_EXPIRED';

const STATUS_CHANGE_TO_DRAFT_SUCCESS = 'STATUS_CHANGE_TO_DRAFT_SUCCESS';
const STATUS_CHANGE_TO_DRAFT = 'STATUS_CHANGE_TO_DRAFT';

const CREATE_TOPUP_MOVE_DISTRIBUTOR = 'CREATE_TOPUP_MOVE_DISTRIBUTOR';
const CREATE_TOPUP_MOVE_DISTRIBUTOR_SUCCESS = 'CREATE_TOPUP_MOVE_DISTRIBUTOR_SUCCESS';

export const unlockUser =
  (body: whitelistUnlockUserRequestBody) =>
  async (dispatch: any): Promise<supportTypeBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/users/users/unlock-user`,
        method: 'POST',
        types: [UNLOCK_USER_SUCCESS, UNLOCK_USER],
        body,
      },
    });
  };

export const whitelistUser =
  (body: checkWhitelistRequestBody) =>
  async (dispatch: any): Promise<supportTypeBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/users/users/whitelist-user`,
        method: 'POST',
        types: [WHITELIST_USER_SUCCESS, WHITELIST_USER],
        body,
      },
    });
  };

export const checkWhitelistUser =
  (body: whitelistUnlockUserRequestBody) =>
  async (dispatch: any): Promise<checkWhitelistedResponceBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/users/users/check-whitelisted`,
        method: 'POST',
        types: [CHECK_WHITELIST_USER_SUCCESS, CHECK_WHITELIST_USER],
        body,
      },
    });
  };

export const changeStatusFromExpiredexport =
  (body: fromExpire) =>
  async (dispatch: any): Promise<fromExpire> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/applications/application-status-change/from-expired`,
        method: 'POST',
        types: [STATUS_CHANGE_FROM_EXPIRED_SUCCESS, STATUS_CHANGE_FROM_EXPIRED],
        body,
      },
    });
  };

export const changeStatusToDraft =
  (body: moveToDraft) =>
  async (dispatch: any): Promise<moveToDraft> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/applications/application-status-change/move-to-draft`,
        method: 'POST',
        types: [STATUS_CHANGE_TO_DRAFT_SUCCESS, STATUS_CHANGE_TO_DRAFT],
        body,
      },
    });
  };

export const unlockAccess =
  () =>
  async (dispatch: any): Promise<unlockAccessBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/users/users/unlocking-access`,
        method: 'GET',
        types: [UNLOCK_USER_ACCESS_SUCCESS, UNLOCK_USER_ACCESS],
      },
    });
  };

export const WhitelistingAccess =
  () =>
  async (dispatch: any): Promise<whitelistAccessBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/users/users/whitelisting-access`,
        method: 'GET',
        types: [WHITELIST_USER_ACCESS_SUCCESS, WHITELIST_USER_ACCESS],
      },
    });
  };

export const changeStatusAccess =
  () =>
  async (dispatch: any): Promise<statusAccessBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/applications/application-status-change/access`,
        method: 'GET',
        types: [STATUS_ACCESS_SUCCESS, STATUS_ACCESS],
      },
    });
  };

export const processSignedApplications =
  () =>
  async (dispatch: any): Promise<void> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/esign/process-signed-applications`,
        method: 'GET',
        types: [STATUS_ACCESS_SUCCESS, STATUS_ACCESS],
        giveResponse: false,
      },
    });
  };
export const makeCompletedApplications =
  (body: makeCompleted) =>
  async (dispatch: any): Promise<void> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/topups/makeCompleted/${body.applicationNumber}`,
        method: 'GET',
        types: [STATUS_ACCESS_SUCCESS, STATUS_ACCESS],
        giveResponse: false,
      },
    });
  };
export const DeleteTopUpApplications =
  () =>
  async (dispatch: any): Promise<void> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/topups/clearAllTopups`,
        method: 'GET',
        types: [STATUS_ACCESS_SUCCESS, STATUS_ACCESS],
        giveResponse: false,
      },
    });
  };

export const topUpMoveDistributor =
  (body: createTopUpMoveDistributor) =>
  async (dispatch: any): Promise<createTopUpMoveDistributor> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/applications/update-users-create-topup`,
        method: 'POST',
        types: [CREATE_TOPUP_MOVE_DISTRIBUTOR_SUCCESS, CREATE_TOPUP_MOVE_DISTRIBUTOR],
        body,
      },
    });
  };
